import { __read } from "tslib";
import React, { useState } from 'react';
import { Popover } from '@hose/eui';
import { renderPopoverContent } from '../../../components/layout/ExceedStandardRiskForField';
import { some, uniq } from 'lodash';
import { riskType } from './type';
import riskStyle from './index.module.less';
import { OutlinedDirectionRight, OutlinedDirectionDown, FilledTipsWarning } from '@hose/eui-icons';
import classnames from 'classnames';
import { flattenObject } from './utils';
var RiskTag = function (props) {
    var _a = props.external, external = _a === void 0 ? [] : _a, _b = props.style, style = _b === void 0 ? {} : _b;
    var _c = __read(useState(''), 2), arrowDirection = _c[0], setArrowDirection = _c[1];
    var flattenRisk = flattenObject(external) || [];
    var num = (flattenRisk === null || flattenRisk === void 0 ? void 0 : flattenRisk.length) || 0;
    var isForbid = some(flattenRisk, { isOutOfLimitReject: true });
    var typeString = flattenRisk === null || flattenRisk === void 0 ? void 0 : flattenRisk.map(function (v) {
        return i18n.get(riskType[v.type]) || v.type;
    });
    var RiskContent = (React.createElement("div", { className: riskStyle['risk-tag-Popover'] }, renderPopoverContent(flattenRisk)));
    var visibleChange = function (visible) {
        visible ? setArrowDirection('top') : setArrowDirection('');
    };
    return (React.createElement(Popover, { trigger: "hover", overlayClassName: "risk-popover", arrowPointAtCenter: true, autoAdjustOverflow: true, content: RiskContent, onOpenChange: function (open) { return visibleChange(open); } },
        React.createElement("div", { className: riskStyle['risk-tag-new'], style: style },
            React.createElement("div", { className: classnames('inner-wrapper', { 'error': isForbid }) },
                React.createElement(FilledTipsWarning, { className: "icon" }),
                React.createElement("span", { className: "number" }, i18n.get("\u6709 {__k0} \u5904{__k1}\u98CE\u9669", { __k0: num, __k1: uniq(typeString).join('、') })),
                React.createElement("span", { className: "more" }, arrowDirection === 'top' ? React.createElement(OutlinedDirectionDown, { className: "ml-2" }) : React.createElement(OutlinedDirectionRight, { className: "ml-2" }))))));
};
export default RiskTag;
